import { Box, Switch, TextField, Typography, ToggleButton, ToggleButtonGroup, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const MultipleChoiceTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, validations, setValidations, options, setOptions, style, setStyle, flexDirection, setFlexDirection, accentColor = "#6366f1" }) => {
  const optionsList = options || ["Option 1", "Option 2"];

  const handleAddOption = () => setOptions([...optionsList, ""]);
  const handleChangeOption = (i, val) => { const u = [...optionsList]; u[i] = val; setOptions(u); };
  const handleDeleteOption = (i) => setOptions(optionsList.filter((_, idx) => idx !== i));

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Display Style</Typography>
        <ToggleButtonGroup value={style || "button"} exclusive size="small" fullWidth
          onChange={(_, v) => v && setStyle(v)}
          sx={{ mb: 2, "& .MuiToggleButton-root": { textTransform: "none", fontSize: 11, fontWeight: 600, flex: 1 } }}>
          <ToggleButton value="button">Button</ToggleButton>
          <ToggleButton value="dropdown">Dropdown</ToggleButton>
          <ToggleButton value="list">List View</ToggleButton>
        </ToggleButtonGroup>

        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Layout Direction</Typography>
        <ToggleButtonGroup value={flexDirection || "column"} exclusive size="small" fullWidth
          onChange={(_, v) => v && setFlexDirection(v)}
          sx={{ "& .MuiToggleButton-root": { textTransform: "none", fontSize: 11, fontWeight: 600, flex: 1 } }}>
          <ToggleButton value="row">↔ Horizontal</ToggleButton>
          <ToggleButton value="column">↕ Vertical</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1.5, color: "#1f2937" }}>Options</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
          {optionsList.map((opt, i) => (
            <Box key={i} sx={{ display: "flex", gap: 0.8, alignItems: "center" }}>
              <Box sx={{ width: 22, height: 22, borderRadius: "50%", bgcolor: `${accentColor}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: accentColor }}>{i + 1}</Typography>
              </Box>
              <TextField fullWidth size="small" placeholder={`Option ${i + 1}`}
                value={typeof opt === "object" ? opt.label || opt.value : opt}
                onChange={(e) => handleChangeOption(i, e.target.value)}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
              <IconButton size="small" onClick={() => handleDeleteOption(i)} sx={{ color: "#ef4444", "&:hover": { bgcolor: "#fef2f2" } }}>
                <DeleteOutlineIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mt: 1.5, cursor: "pointer", color: accentColor, "&:hover": { color: accentColor, filter: "brightness(0.85)" } }}
          onClick={handleAddOption}>
          <AddIcon sx={{ fontSize: 16 }} />
          <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Add Option</Typography>
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField fullWidth label="Min Selections" type="number" size="small"
            value={validations?.minLength ?? ""} onChange={(e) => setValidations({ ...validations, minLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
          <TextField fullWidth label="Max Selections" type="number" size="small"
            value={validations?.maxLength ?? ""} onChange={(e) => setValidations({ ...validations, maxLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
        </Box>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please select at least one option" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default MultipleChoiceTab;
